import { clsx, type ClassValue } from "clsx";
import { twMerge } from "tailwind-merge";

/**
 * A utility function that merges class names with Tailwind CSS classes.
 * Uses clsx for conditional classes and tailwind-merge to handle conflicting classes.
 */
export function cn(...inputs: ClassValue[]) {
	return twMerge(clsx(inputs));
}
